<template>
  <div>
    <nestable-tree id="nestable"
                   :value="selectedLocals"
                   :options="options"
                   :normalizer="normalizer"
                   :always-open="true"
                   :no-options-text="$t('message.automation.message.noSpotRegistered')"
                   :placeholder="$t('message.generics.message.spots')"
                   @select="addLocal"
                   @deselect="removeLocal">
      <div slot="option-label"
           slot-scope="{ node }">
        <filter-local-tree-item :node="node" />
      </div>
    </nestable-tree>
  </div>
</template>

<script>
import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
import NestableTree from "@/components/generic/nestable/tree/NestableTree";
import { cloneDeep } from "lodash";

export default {
  components: {
    NestableTree,
    FilterLocalTreeItem,
  },

  data() {
    return {
      normalizer(node) {
        return {
          id: node.localTreeId,
          label: node.name,
          children: node.children,
        };
      },
      valToEmit: [],
      selectedLocals: [],
      options: []
    };
  },  

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    item: {
      type: Object,
    }
    
  },  

  methods: {
    addLocal(node) {
      this.valToEmit = cloneDeep(this.value);

      this.addLocalVal(node);

      this.$emit("input", this.valToEmit);
    },
    removeLocal(node) {
      this.valToEmit = cloneDeep(this.value);

      this.removeLocalVal(node);

      this.$emit("input", this.valToEmit);
    },
    addLocalVal(node) {
      if (node.type === 1) {
        this.valToEmit.push(node.objectId);
      }

      if (node.type === 0) {
        if (!node.children) {
          return;
        } else {
          node.children.map((childNode) => {
            this.addLocal(childNode);
          });
        }
      }
    },
    removeLocalVal(node) {
      if (node.type === 1) {
        const newLocals = this.valToEmit.filter(
          (localId) => localId !== node.objectId
        );
        this.valToEmit = [...newLocals];
      }

      if (node.type === 0) {
        if (!node.children) {
          return;
        } else {
          node.children.map((childNode) => {
            this.removeLocal(childNode);
          });
        }
      }
    },
    async loadLocalOptions() {
      this.options = await this.$api.core.account.captiveStyle.locals({
        styleId: this.item.id,
      });

      this.removeLastChildren(this.options);
    },
    removeLastChildren(locals) {
      for (const local of locals) {
        if (local.children.length > 0) {
          this.removeLastChildren(local.children);
        } else {
          local.children = undefined;
        }
      }

      return locals;
    },
    addLocalTreeId(node, objId) {
      if (node.type === 1 && node.objectId === objId) {
        this.selectedLocals.push(node.localTreeId);
      }

      if (node.type === 0) {
        if (!node.children) {
          return;
        } else {
          node.children.map((childNode) => {
            this.addLocalTreeId(childNode, objId);
          });
        }
      }
    },
  },

  async mounted() {   
    this.options = await this.$api.core.account.captiveStyle.locals({
      styleId: this.item.id,
    });
    this.removeLastChildren(this.options);
    this.value.map((objId) => {
      this.options.map((node) => {
        this.addLocalTreeId(node, objId);
      });
    });    
  },

  beforeDestroy() {},

  mixins: [],
};
</script>

<style lang="scss" >
#nestable {
  .vue-treeselect__control {
    display: none !important;
  }
  .vue-treeselect__menu-container {
    position: static !important;

    .vue-treeselect__menu {
      position: static !important;
      border: none;

      .vue-treeselect__checkbox {
        width: 15px;
        height: 15px;
      }

      .vue-treeselect__checkbox--checked {
        .vue-treeselect__check-mark {
          margin-left: 2px;
          margin-top: 1px;
        }
      }

      .vue-treeselect__checkbox--indeterminate {
        .vue-treeselect__minus-mark {
          margin-left: 2px;
          margin-top: 1px;
        }
      }

      .nestable-tree-option {
        font-size: 16px;

        svg {
          height: 20px !important;
        }

        i {
          font-size: 20px;
        }

        .filter-local-tree-item-icon {
          width: 20px !important;
        }
      }
    }
  }
}
</style>
